import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { TranslateService } from '@ngx-translate/core';

import { HttpBase } from 'app/services/http-base.service';

@Injectable()
export class LoginService extends HttpBase {
    constructor(http: HttpClient, router: Router, translateService: TranslateService) {
        super(http, router, translateService);
    }

    login = (userName: string, password: string, remember: boolean): Observable<{ success: boolean }> => {
        return this.post<{ success: boolean }>('/api/home/login', { userName, password, remember });
    }

    logout = (): Observable<{ success: boolean }> => {
        return this.post<{ success: boolean }>('/api/home/logout', null);
    }

    getSiteAddress = (): Observable<{ success: boolean, siteAddress: string }> => {
        return this.get<{ success: boolean, siteAddress: string }>('/api/home/getsiteaddress');
    }
}



// WEBPACK FOOTER //
// ./src/app/services/login.service.ts